module.exports = {"id":"213955","name":"Sardar Azmoun","rating":"76","photo":"./data/images/photos/3/213955.png","club":{"name":"Rubin Kazan","logo":"./data/images/clubs/RubinKazan.png"},"positions":["BU"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/SardarAzmoun0.json
// module id = 3834
// module chunks = 0